import { inject, Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { AlertOptions, AlertService } from '../alert.service';

@Injectable()
export class AlertToastService extends AlertService {
  #snackBar = inject(MatSnackBar);

  show(message: string, options?: AlertOptions): void {
    const config = this.#createConfig(options);
    this.#snackBar.open(message, options?.action || 'Cerrar', config);
  }

  showSuccess(message: string, options?: AlertOptions): void {
    const config = this.#createConfig(options, 'success');
    this.#snackBar.open(message, options?.action || 'Cerrar', config);
  }

  showError(message: string, options?: AlertOptions): void {
    const config = this.#createConfig(options, 'error');
    this.#snackBar.open(message, options?.action || 'Cerrar', config);
  }

  showInfo(message: string, options?: AlertOptions): void {
    const config = this.#createConfig(options, 'info');
    this.#snackBar.open(message, options?.action || 'Cerrar', config);
  }

  showWarning(message: string, options?: AlertOptions): void {
    const config = this.#createConfig(options, 'warning');
    this.#snackBar.open(message, options?.action || 'Cerrar', config);
  }

  #createConfig(_options?: AlertOptions, type?: string): MatSnackBarConfig {
    let config: MatSnackBarConfig = {};

    config = {
      duration: _options?.duration || 5000,
    };

    if (type) {
      const typeClass = this.#getTypeClass(type);
      config.panelClass = [...(config.panelClass || []), typeClass];
    }

    return config;
  }

  #getTypeClass(type: string): string {
    const classMap: Record<string, string> = {
      success: 'toast-success',
      error: 'toast-error',
      info: 'toast-info',
      warning: 'toast-warning',
    };
    return classMap[type] || '';
  }
}
